<template>
    <el-dialog title="请联系管理员完成授权" width="25%" show-close :visible.sync="tipsDialog">
        <p>{{ content }}</p>
        <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="tipsDialog = false">我知道了</el-button>
            </div>
    </el-dialog>
</template>
<script>

export default {
    data() {
        return {
            tipsDialog: false,
            content: ''
        }
    },
    methods: {
        initTips(value) {
            this.content = value
            this.tipsDialog = true
        }
    }
}
</script>